<template>
  <div class="pages">
    <div class="pageContent infoPage">
      <div class="steps-background-wrapper">
        <img class="steps-background" src="@/assets/img/stepsBg.png" alt="" />
      </div>
      <van-steps :active="stepActive" class="info-steps staff-steps" v-show="language === 'zh'">
        <van-step class="staff-step">{{ $t('steps.person') }}</van-step>
        <van-step class="staff-step">{{ $t('steps.contact') }}</van-step>
        <van-step class="staff-step">{{ $t('steps.trip') }}</van-step>
      </van-steps>
      <van-steps :active="stepActive" class="info-steps staff-steps info-steps-English" v-show="language === 'en'">
        <van-step class="staff-step">{{ $t('steps.person') }}</van-step>
        <van-step class="staff-step">{{ $t('steps.contact') }}</van-step>
        <van-step class="staff-step">{{ $t('steps.trip') }}</van-step>
      </van-steps>
      <div class="step-content">
        <person-info v-show="stepActive === 0" ref="personInfo" />
        <contact-info v-show="stepActive === 1" ref="contactInfo" />
        <trip-info v-show="stepActive === 2" ref="tripInfo" />
        <div class="information-box button-group" v-if="btnShow">
          <van-button :disabled="submitLoading" type="info" @click="goNext">{{ stepActive === 2 ? $t('form.label.submit') :
            $t('form.label.next') }}</van-button>
          <van-button plain type="info" v-show="stepActive > 0" @click="goPrev">{{ $t('form.label.previous') }}</van-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getPersonInfo, submitInfo, updateArrival, updateLeave, updateAccommodate } from '@/api/worker'
import { getConferenceInfo } from '@/api/conference'
import PersonInfo from './staff/personInfo.vue'
import ContactInfo from './staff/contactInfo'
import TripInfo from './staff/tripInfo'
import { mapGetters } from 'vuex'
import MonitorKeyboard from '@/utils/monitorKeyboard.js'

export default {
  name: 'staffRegis',
  components: { PersonInfo, ContactInfo, TripInfo },
  data() {
    return {
      stepActive: 0,
      guestInfo: true,
      language: 'zh',
      form: {
        conferenceId: this.$route.params.conferenceId
      },
      btnShow: true,
      submitLoading: false,
      updateCount: 0,
      runCount: 0,
    }
  },
  computed: {
    ...mapGetters(['status'])
  },
  mounted() {
    if (this.status === 'AUDIT') {
      this.finish()
      return
    }
    this.language = this.$i18n.locale
    if (this.status) {
      this.getPersonInfo()
    } else {
      this.$nextTick(() => {
        this.$refs.personInfo.initForm(this.form)
      })
    }
  },
  methods: {
    getPersonInfo() {
      getPersonInfo().then(res => {
        this.form = res.data
        this.$nextTick(() => {
          this.$refs.personInfo.initForm(this.form)
        })
      })
    },
    goNext() {
      if (this.stepActive < 3) {
        if (this.stepActive === 0) {
          this.$refs.personInfo.validate().then(() => {
            this.form = Object.assign({}, this.form, this.$refs.personInfo.form)
            this.$refs.contactInfo.initForm(this.form)
            this.stepActive++
          })
        } else if (this.stepActive === 1) {
          this.$refs.contactInfo.validate().then(() => {
            this.form = Object.assign({}, this.form, this.$refs.contactInfo.form)
            this.$refs.tripInfo.initForm(this.form)
            this.stepActive++
          })
        } else if (this.stepActive === 2) {
          this.$refs.tripInfo.validate().then(() => {
            this.form = Object.assign({}, this.form, this.$refs.tripInfo.form)
            if (this.submitLoading) {
              return
            }
            this.submitLoading = true
            if (this.status !== 'ENABLE') {
              getConferenceInfo({ conferenceId: this.$route.params.conferenceId }).then(res => {
                if (this.$checkTimeBetween(res.data.workerRegisterStartTime, res.data.workerRegisterEndTime)) {
                  this.submitInfo()
                } else {
                  this.finishError()
                  this.$notify('注册已结束')
                }
              })
            } else {
              getConferenceInfo({ conferenceId: this.$route.params.conferenceId }).then(res => {
                // if (this.$checkTimeBetween(res.data.modificationStartTime, res.data.modificationEndTime)) {
                  this.updateInfo()
                // } else {
                //   this.$notify(this.$t3('不在修改信息时间内', 'Not in the time of information modification'))
                // }
              })
            }
          })
        }
      }
    },
    goPrev() {
      if (this.stepActive > 0) {
        if (this.stepActive === 1) {
          this.form = Object.assign({}, this.form, this.$refs.contactInfo.form)
          this.$refs.personInfo.initForm(this.form)
          this.stepActive--
        } else if (this.stepActive === 2) {
          this.form = Object.assign({}, this.form, this.$refs.tripInfo.form)
          this.$refs.contactInfo.initForm(this.form)
          this.stepActive--
        }
      }
    },
    // 提交全部信息
    submitInfo() {
      submitInfo(this.form).then(res => {
        if (res.success) {
          this.$store.commit('user/SET_NEED_UPDATE_INFO', false)
          this.finish()
        } else {
          this.finishError()
        }
      }, err => {
        this.finishError()
      })
    },
    // 修改部分信息
    updateInfo() {
      this.updateCount = 0
      this.runCount = 0
      const form = this.$refs.tripInfo.form
      const arrivalData = { id: this.form.arrivalId, workerId: this.form.id }
      const leaveData = { id: this.form.leaveId, workerId: this.form.id }
      for (const key in form) {
        arrivalData[key.replace(/A$/, '')] = form[key]
        leaveData[key.replace(/L$/, '')] = form[key]
      }
      const accommodationData = { location: form.location, id: this.form.id }
      updateArrival(arrivalData).then(res => {
        this.runCount++
        if (res.success) {
          if (++this.updateCount >= 3) {
            this.finish()
          }
        } else if (this.runCount >= 3) {
          this.finishError()
        }
      }, err => {
        this.runCount++
        if (this.runCount >= 3) {
          this.finishError()
        }
      })
      updateLeave(leaveData).then(res => {
        this.runCount++
        if (res.success) {
          if (++this.updateCount >= 3) {
            this.finish()
          }
        } else if (this.runCount >= 3) {
          this.finishError()
        }
      }, err => {
        this.runCount++
        if (this.runCount >= 3) {
          this.finishError()
        }
      })
      updateAccommodate(accommodationData).then(res => {
        this.runCount++
        if (res.success) {
          if (++this.updateCount >= 3) {
            this.finish()
          }
        } else if (this.runCount >= 3) {
          this.finishError()
        }
      }, err => {
        this.runCount++
        if (this.runCount >= 3) {
          this.finishError()
        }
      })
    },
    finish() {
      this.submitLoading = false
      // TODO 跳转页面
      if (this.status === 'ENABLE') {
        this.$router.push('mediaSuccess')
      } else {
        this.$router.push('mediaConfirm')
      }
    },
    finishError() {
      this.submitLoading = false
    },
    // 监听软键盘是否弹出
    getKeyboardState() {
      this.monitorKeyboard = new MonitorKeyboard();
      this.monitorKeyboard.onStart();

      // 监听虚拟键盘弹出事件
      this.monitorKeyboard.onShow(() => {
        // alert('键盘弹出')
        this.btnShow = false
      })

      //监听键盘收起的事件
      this.monitorKeyboard.onHidden(() => {
        // alert('键盘收起')
        this.btnShow = true
      })
    },
    beforeDestroy() {
      this.monitorKeyboard.onEnd();
    }
  }
}
</script>